import React, {useEffect, useState} from 'react';

import Header from "./header"
import Footer from "./footer"
import LeftMenu from "./left-menu"
import {PUBLIC_URL} from './../../const'

const getInitialLang = () => (localStorage.getItem("lang") || "").toLowerCase() || "en";

const MainFrame = ({ children }) => {
    const [lang, setLang] = useState(getInitialLang());

    const childrenWithLang = React.Children.map(children, (child) =>
        React.isValidElement(child) ? React.cloneElement(child, { lang, setLang }) : child
    );

    useEffect(() => {
        document.documentElement.lang = lang;
        localStorage.setItem("lang", lang);
    }, [lang]);

    return (
        <>
            <div class="preloader" style={{display: "none"}}>
                <img src={`${PUBLIC_URL}/assets/images/logos/favicon.png`} alt="loader" class="lds-ripple img-fluid" />
            </div>
            <div id="main-wrapper">
                <aside class="left-sidebar with-vertical">
                    <div>
                        <LeftMenu lang={lang} setLang={setLang}/>
                    </div>
                </aside>
                <div class="page-wrapper">
                    <header class="topbar">
                        <div class="with-vertical">
                            <Header lang={lang} setLang={setLang} />
                        </div>
                        <div class="app-header with-horizontal">

                        </div>
                    </header>

                    <aside class="left-sidebar with-horizontal">

                    </aside>

                    <div class="body-wrapper">
                        <div class="container-fluid">
                            {childrenWithLang}
                        </div>
                    </div>

                </div>
            </div>
            <div class="dark-transparent sidebartoggler"></div>
        </>
    )
}

export default MainFrame
